import React, { useState, useEffect } from 'react'
import { Form, Input, Switch } from 'antd'
import bxlutils from 'bxl-utils'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import utils from '@utils/utils'

export interface IFormProps {
  setParams: (params: any, p?: string) => void
}

interface IProductParam {
  productId?: string
  sku?: string
  groupBuy?: boolean
}
const FormItem = Form.Item
const ProductDetail = (props: IFormProps) => {
  const [productParams, setproductParams] = useState<IProductParam>({})
  const { setParams } = props
  const changeText = (name, e) => {
    const value = typeof e === 'boolean' ? e : e.target.value.trim()
    setproductParams({
      ...productParams,
      [name]: value,
    })
  }
  useEffect(() => {
    if (productParams.productId || productParams.sku || productParams.groupBuy)
      bxlutils.throttle(500, setParams(productParams))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productParams])
  return (
    <>
      <FormItem label="Product ID">
        <Input onChange={e => changeText('productId', e)}></Input>
      </FormItem>
      <FormItem label="SKU ID">
        <Input onChange={e => changeText('sku', e)}></Input>
      </FormItem>
      <FormItem label="拼团链接">
        <Switch onChange={e => changeText('groupBuy', e)}></Switch>
      </FormItem>
    </>
  )
}

export default ProductDetail
